import { Link, LinkProps } from '@wegroup/design-system';
import React, { PropsWithChildren } from 'react';

const OfferActionLink: React.FC<PropsWithChildren<LinkProps>> = ({
  children,
  ...props
}) => {
  return (
    <Link m="4" variant="gray" textAlign="center" {...props}>
      {children}
    </Link>
  );
};

export default OfferActionLink;
